<div class="backdrop" [ngStyle]="{'display':modal.display}"></div>
<div [ngStyle]="{'display':modal.display}" class="modal" id="checkConfirm" tabindex="-1" role="dialog"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <img src="assets\images\close_icon.png" alt="close_button" title="close_button" (click)="modal.closeFunction()"
          class="close-ico">
        <h4 class="modal-title" id="modalTitle">{{modal.header}}</h4>
      </div>
      <div class="modal-body d-flex flex-column justify-content-center">
        <section class="d-flex flex-column justify-content-center">
          <div class="d-flex flex-column justify-content-center modal-txt">{{modal.content}}</div>
        </section>
      </div>
      <div class="d-flex justify-content-around modal-foot">
        <button type="button" class="btn btn-secondary modal-btn" role="button" data-toggle="modal"
          data-target="#Success" data-dismiss="modal" (click)="modal.closeFunction()" role="button" data-toggle="modal">
          {{modal.okButton}}
        </button>
      </div>
    </div>
  </div>
</div>